// Customizable Area Start
import React from 'react';
import { Grid, styled } from '@material-ui/core';
import { ChatBubbleLargeIcon, ChatBubbleSmallIcon, HeartIcon, StarIcon,message } from './assets';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DashboardController from './DashboardController.web';

class Reactions extends DashboardController {

  render() {
    const { reactionCount } = this.state
    
    return (
      <Paper square elevation={0}>
      <ReactionGrid
        container
        justifyContent="center">
        <Grid item className='reactionData'>
          <img src={HeartIcon} className='iconStyle likeIcon'/>
          <Typography
            data-test-id="likeCount"
            variant="subtitle2"
            align="center"
            className='iconCount'>
            {reactionCount.likes}
          </Typography>
        </Grid>
        <Grid item className='reactionData'>
          <img src={ChatBubbleLargeIcon} className='iconStyle messageIcon'style={{padding: "2px"}}/>
          <Typography
            data-test-id="commentCount"
            variant="subtitle2"
            align="center"
            className='iconCount'>
            {reactionCount.comments}
          </Typography>
        </Grid>
        <Grid item className='reactionData' onClick={() => {this.props.navigation?.history?.push('/ReviewsBUser')}}>
          <img src={StarIcon} className='iconStyle starIcon'/>
          <Typography
            data-test-id="reviewCount"
            variant="subtitle2"
            align="center"
            className='iconCount'>
            {reactionCount.reviews}
          </Typography>
        </Grid>
      </ReactionGrid>
    </Paper>
    );
  }
}
export { Reactions }

const ReactionGrid = styled(Grid)({
  padding: "8px",
  gap: "16px",
  "& .iconStyle": {
    width: "45px",
    height: "40px",
    "@media (max-width: 960px)": {
      width: "25px",
      height: "20px"
    }
  },
  "& .reactionData": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "0",
    padding: "4px",
    // "@media (max-width: 960px)": {
    //   // padding: "8px 4px",
    //   minHeight: "60px",
    //   justifyContent: "space-between"
    // },
    "@media (max-width: 480px)": {
      // padding: "6px 2px",
      // minHeight: "50px",
    flex: "1",
    }
  },
  "& .iconCount": {
    color: '#FF0000',
    fontStyle:"normal",
    fontSize:"14px",
    fontWeight: 600,
    fontFamily:"Inter",
    marginTop: "4px",
    textAlign: "center",
    "@media (max-width: 960px)": {
      fontSize: "12px",
      fontWeight: 600,
      color: "#FF0000",
      marginTop: "8px",
      lineHeight: "1.2"
    },
    "@media (max-width: 480px)": {
      fontSize: "10px",
      // marginTop: "6px"
    }
  },
  "& .likeIcon": {
    width: "25px !important",
    height: "25px !important",
    "@media (max-width: 960px)": {
      width: "20px !important",
      height: "20px !important"
    },
    "@media (max-width: 480px)": {
      width: "20px !important",
      height: "20px !important"
    }
  },
  "& .messageIcon":{
    width: "29px !important",
    height: "29px !important",
    "@media (max-width: 960px)": {
      width: "27px !important",
      height: "27px !important"
    },
    "@media (max-width: 480px)": {
      width: "25px !important",
      height: "24px !important"
    }
  },
  "& .starIcon": {
    width: "30px !important",
    height: "30px !important",
    "@media (max-width: 960px)": {
      width: "24px !important",
      height: "24px !important"
    },
    "@media (max-width: 480px)": {
      width: "25px !important",
      height: "24px !important"
    }
  },
  "@media (max-width: 960px)": {
    // gap: "12px",
    // padding: "16px 12px",
    // borderRadius: "8px",
    // margin: "8px 0",
    backgroundColor: "#f1f5f9"
  },
  "@media (max-width: 480px)": {
    // gap: "8px",
    // padding: "12px 8px",
    // borderRadius: "6px",
    // margin: "6px 0",
  }
})

// Customizable Area End
